import OrganizationTab from './OrganizationTab'
export default OrganizationTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/OrganizationTab/index.js